<template>
	<input title="time" v-mask="'##:##'" v-model="time" @change="updateDate(time)">
</template>
<script>
	import moment from 'moment';

	export default {
		name: "changeTime",
		props: ['date'],
		mounted() {
			this.day = moment(this.date, 'X').format('DD.MM.YYYY');
			this.time = moment(this.date, 'X').format('HH:mm');
		},
		data() {
			return {
				day: 0,
				time: 0
			}
		},
		methods: {
			updateDate(time) {
				let parts = time.split(':');

				if(+parts[0] > 23) {
					time = 23 + ':' + parts[1];
				} else if(+parts[1] > 59) {
					time = parts[0] + ':' + 59;
				}

				this.time = time;

				this.$emit('inputTime', moment(this.day + ' ' + time, 'DD.MM.YYYY HH:mm').format('X'))
			}
		}
	}
</script>
<style></style>



// WEBPACK FOOTER //
// changeTime.vue?20896422